export default __webpack_public_path__ + "assets/images/619fa20d557eccb24c2637386df1af9b.png";